import Table from "react-bootstrap/Table";
import Loading from "../../../components/LoadingPage/Loading";
import "./vendorsettingsview.scss";

export interface McKessonVendorDetail {
  id: string;
  vendorMasterId: string;
  clientName: string;
  identity: string;
  sharedSecret: string;
  account: string;
  externalOrderRefNoPrefix: string;
}

export interface McKessonShippingLocation {
  id: string;
  vendorMasterId: string;
  shippingLocationId: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  isDefault: boolean;
  mappedLocationId: string | null;
}

export interface McKessonApiEntry {
  id: string;
  vendorMasterId: string;
  identifier: string;
  url: string;
}

interface VendorSettingsViewProps {
  vendorDetail: McKessonVendorDetail | null;
  shippingLocations: McKessonShippingLocation[];
  apiEntries: McKessonApiEntry[];
  isLoading?: boolean;
}

const VendorSettingsView: React.FC<VendorSettingsViewProps> = ({
  vendorDetail,
  shippingLocations: apiShippingLocations,
  apiEntries,
  isLoading,
}) => {

  return (
    <div className="vendor-settings-view">
      {isLoading && <Loading />}
      <div className="settings-info-fields">
        <div className="profile-info-box">
          <label>Identity</label>
          <p>{vendorDetail?.identity || "-"}</p>
        </div>
        <div className="profile-info-box">
          <label>Shared Secret</label>
          <p>{vendorDetail?.sharedSecret || "-"}</p>
        </div>
        <div className="profile-info-box">
          <label>Account</label>
          <p>{vendorDetail?.account || "-"}</p>
        </div>
        <div className="profile-info-box">
          <label>Ref No Prefix</label>
          <p>{vendorDetail?.externalOrderRefNoPrefix || "-"}</p>
        </div>
        <div className="profile-info-box">
          <label>Client Name</label>
          <p>{vendorDetail?.clientName || "-"}</p>
        </div>
      </div>

      {apiShippingLocations.length > 0 && (
        <div className="settings-view-section">
          <h6 className="section-title">Shipping Locations</h6>
          <Table responsive="md" hover className="settings-view-table">
            <thead>
              <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>Zip</th>
                <th>Location</th>
                <th>Default?</th>
              </tr>
            </thead>
            <tbody>
              {apiShippingLocations.map((loc, index) => (
                <tr key={index}>
                  <td>{loc.shippingLocationId}</td>
                  <td>{loc.name}</td>
                  <td>{loc.address}</td>
                  <td>{loc.city}</td>
                  <td>{loc.state}</td>
                  <td>{loc.zip}</td>
                  <td>{loc.mappedLocationId || "-"}</td>
                  <td>{loc.isDefault ? "True" : "False"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {apiEntries.length > 0 && (
        <div className="settings-view-section">
          <h6 className="section-title">Urls</h6>
          <Table responsive="md" hover className="settings-view-table">
            <thead>
              <tr>
                <th>Identifier</th>
                <th>URL</th>
              </tr>
            </thead>
            <tbody>
              {apiEntries.map((api, index) => (
                <tr key={index}>
                  <td>{api.identifier}</td>
                  <td>{api.url}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default VendorSettingsView;
